import React from 'react'
import QualityIncidenceActionsTable from './QualityIncidenceActionsTable'

const QualityActions = () => {
  return (
    <QualityIncidenceActionsTable
      global
      tableKey='qualityIncidenceActionsAll'
    />
  )
}

export default QualityActions
